import backgroundM from "../../images/home/background-home-mobile.jpg";
import bgTab from "../../images/home/background-home-tablet.jpg";
import bgDesk from "../../images/home/background-home-desktop.jpg";
import NavBar from "../navbar/MainNavBar";
import { useMediaQuery } from "@mui/material";

const Home = () => {
  const mobileQuery = useMediaQuery("(min-width:768px)");
  const tabQuery = useMediaQuery("(min-width:1440px)");
  const styleM = {
    backgroundImage: `url(${backgroundM})`,
    backgroundSize: "cover",
    minHeight: "100vh",
  };
  const styleTab = {
    backgroundImage: `url(${bgTab})`,
    backgroundSize: "cover",
    minHeight: "100vh",
  };
  const styleDesk = {
    backgroundImage: `url(${bgDesk})`,
    backgroundSize: "cover",
    minHeight: "100vh",
  };
  return (
    <div style={!mobileQuery ? styleM : !tabQuery ? styleTab : styleDesk}>
      <NavBar />
      <div className="home-div">
        <div>
          <p className="p-style">SO, YOU WANT TO TRAVEL TO</p>
          <h1
            style={
              !mobileQuery
                ? {
                    fontSize: "5rem",
                    margin: " 2rem 0 1rem",
                  }
                : !tabQuery
                ? {
                    fontSize: "9rem",
                    margin: " 2rem 0 1rem",
                  }
                : {
                    fontSize: "9rem",
                    margin: " 2rem 0 1rem",
                  }
            }
          >
            SPACE
          </h1>
          <p
            style={
              !mobileQuery || !tabQuery
                ? {
                    color: "#D0D6F9",
                    fontSize: "13px",
                    lineHeight: "25px",
                    fontWeight: 400,
                    letterSpacing: "2.7px",
                    margin: " 1rem .5rem 4rem",
                  }
                : {
                    color: "#D0D6F9",
                    fontSize: "16px",
                    lineHeight: "25px",
                    fontWeight: 400,
                    letterSpacing: "2.7px",
                    margin: " 1rem .5rem 4rem",
                    width: "46%",
                  }
            }
          >
            Let’s face it; if you want to go to space, you might as well
            genuinely go to outer space and not hover kind of on the edge of it.
            Well sit back, and relax because we’ll give you a truly out of this
            world experience!
          </p>
        </div>
        <div className="explore-div">
          <p>EXPLORE</p>
        </div>
      </div>
    </div>
  );
};
export default Home;
